module.exports = __webpack_public_path__ + "static/media/26.887a88c5.jpg";